import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@/App.css";
import PasswordGate from "@/components/PasswordGate";
import Dashboard from "@/components/reports/Dashboard";
import FWACaseAnalysis from "@/components/reports/FWACaseAnalysis";
import StateBriefing from "@/components/reports/StateBriefing";
import TaskForceBrief from "@/components/reports/TaskForceBrief";

function App() {
  return (
    <Router>
      <PasswordGate>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/reports/fwa-case-analysis" element={<FWACaseAnalysis />} />
          <Route path="/reports/state-briefing" element={<StateBriefing />} />
          <Route path="/reports/task-force-brief" element={<TaskForceBrief />} />
        </Routes>
      </PasswordGate>
    </Router>
  );
}

export default App;
